import React from 'react';

const Bahrain = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" fill="#F93939" />
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H9.33333V20H0V0ZM9.33333 0L12 2L9.33333 4V0ZM9.33333 4L12 6L9.33333 8V4ZM9.33333 8L12 10L9.33333 12V8ZM9.33333 12L12 14L9.33333 16V12ZM9.33333 16L12 18L9.33333 20V16Z"
      fill="white"
    />
  </svg>
);

export default Bahrain;
